import React, { useState, useEffect } from 'react';
import { GridToolbar, DataGrid } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useDemoData } from '@mui/x-data-grid-generator';

import { API_URL } from '../../services/api-uri';
import authHeader from '../../services/auth-header';
import { useNavigate } from 'react-router-dom';
import { LinearProgress, Stack } from '@mui/material';

const BookingGrid = ({ columns, StatusToText, TextToStatus, filter, statusFilter, yearFilter, centerFilter, agencyFilter }) => {

    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(100);

    const { user: currentUser } = useSelector((state) => state.auth);

    const [total, setTotal] = useState(0);
    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false)

    const handleRowClick = (params) => {
        if (params.id > 0) {
            let booking = rows.filter((b) => b.id == params.id)[0];
            if (booking != null) {
                navigate(`/bookings-management/${booking.id}`, { state: booking.id });
            }
        }
    };

    // Un SEUL effet pour tous les filtres. Avant : 5 useEffect declenchaient autant
    // de fetch concurrents au montage (retour / F5) et les resultats etaient EMPILES
    // (setRows([...prev, ...data])) -> liste doublee/triplee.
    // Ici : debounce + remplacement (setRows(data)) + flag "cancelled" qui ignore toute
    // reponse obsolete (filtre change ou composant demonte avant la fin du fetch).
    useEffect(() => {

        if (filter === undefined) {
            return;
        }

        let cancelled = false;
        setLoading(true);

        const timerId = setTimeout(async () => {
            try {
                const params = {
                    params: {
                        id_user: currentUser.id,
                        page: page,
                        pageSize: pageSize,
                        filter: filter,
                        statusFilter: statusFilter.map(m => TextToStatus(m)).join(),
                        centerFilter: centerFilter,
                        agencyFilter: agencyFilter,
                        yearFilter: yearFilter.split('-')[1]
                    },
                    headers: authHeader(),
                };

                const response = await axios.get(API_URL + 'Bookings', params);

                if (cancelled) return;

                setTotal(response.data.totalRows);
                setRows(response.data.data);
            } catch (error) {
                if (!cancelled) {
                    console.error('Error fetching bookings:', error);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }, 300);

        return () => {
            cancelled = true;
            clearTimeout(timerId);
        };

    }, [filter, statusFilter, centerFilter, agencyFilter, yearFilter, page, pageSize]);


    return (
        <>

            <DataGrid
                autoHeight
                rows={
                    rows.map((booking, index) => ({
                        ...booking,
                        Center: `${booking.centerName}`,
                        Student: `${booking.studentFirstName} ${booking.studentLastName}`,
                        Status: `${StatusToText(booking.status)}`,
                        Date: `${dayjs(booking.datetimeCreation).format('DD/MM/YYYY')}`,
                        Arrival: booking.arrivalHour ? `${dayjs(booking.arrivalHour).format('DD/MM/YYYY')}` : '',
                        Departure: booking.departureHour ? `${dayjs(booking.departureHour).format('DD/MM/YYYY')}` : '',
                        Agency: booking.agencyName ? `${booking.agencyName}` : '',
                    }))
                }
                compo={{
                    loadingOverlay: LinearProgress,
                }}
                loading={loading}
                onRowClick={handleRowClick}
                columns={columns}

            />
        </>
    );
};

export default BookingGrid;
